export default ({ onClick, children, ...rest }) => {
  function _onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  }

  return (
    <a {...rest} href="#" onClick={_onClick}>
      {children}
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/link-like.jsx